import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type FinancePriceDisplayMultiClasses =
  | 'financePriceContainer'
  | 'financePrice'
  | 'priceGroup'
  | 'referenceNumber'
  | 'orLabel'
  | 'priceContainer'
  | 'multiCurrencyPriceContainer'
  | 'priceLabel'
  | 'informativeSection'
  | 'cta';

const financePriceDisplayMultiStyles = makeStyles<ISpcTheme, FinancePriceDisplayMultiClasses>(
  ({ typography, breakpoints, palette }) => ({
    priceContainer: {
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'flex-start',
    },
    priceGroup: {
      display: 'flex',
      alignItems: 'baseline',
    },
    financePriceContainer: {
      display: 'flex',
      flexDirection: 'row',

      [breakpoints.down('xs')]: {
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    financePrice: {
      fontFamily: typography.fontFamily,
      color: palette.primary.main,
      fontSize: typography.fontLG,
      fontWeight: typography.fontWeightBold,
      lineHeight: '24px',

      [breakpoints.down('xs')]: {
        fontSize: typography.fontMD,
        lineHeight: '14px',
      },
    },
    referenceNumber: {
      textAlign: 'left',
      color: palette.primary.main,
      textTransform: 'uppercase',
      alignSelf: 'center',
      paddingLeft: '5px',
      paddingBottom: '4px',
      fontSize: typography.fontXS,
      [breakpoints.down(breakpoints.values.sm)]: {
        textTransform: 'lowercase',
      },
    },
    orLabel: {
      margin: `0 5px`,
      fontFamily: typography.fontFamily2,
      color: palette.primary.main,
    },
    priceLabel: {
      textAlign: 'center',
      lineHeight: '14px',

      [breakpoints.down('xs')]: {
        lineHeight: '12px',
      },
    },
    multiCurrencyPriceContainer: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    informativeSection: {
      display: 'none',
      [breakpoints.down('xs')]: {
        display: 'flex',
        minWidth: '80px',
      },
    },
    cta: {
      display: 'flex',
      margin: 'auto',
      paddingLeft: '20px',

      [breakpoints.down('xs')]: {
        display: 'none',
      },
    },
  }),
  { name: 'ConfigSummary_FinancePriceDisplayMulti' },
);

export default financePriceDisplayMultiStyles;
